import { render, staticRenderFns } from "./DeliveryDateConfirmList.vue?vue&type=template&id=2977f60d&scoped=true"
import script from "./DeliveryDateConfirmList.vue?vue&type=script&lang=js"
export * from "./DeliveryDateConfirmList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977f60d",
  null
  
)

export default component.exports